import React from 'react';

const compliance = ['21 CFR Part 11', 'EU Annex 11 & 16', 'GAMP 5'];
const links = [
  { label: 'Why Qualicore', href: '#why' },
  { label: 'Workflow', href: '#workflow' },
  { label: 'Features', href: '#features' },
  { label: 'Integrations', href: '#integrations' },
  { label: 'Data Sheet', href: '#resources' },
  { label: 'Technical Specs', href: '#specifications' },
  { label: 'Implementation', href: '#implementation' },
  { label: 'Architecture', href: '#architecture' },
  { label: 'Case Study', href: '#case-study' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'Roadmap', href: '#roadmap' },
];

export default function Footer({ onBookDemo }) {
  return (
    <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '60px 24px 40px',
      background: 'rgba(13,17,23,0.95)',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 40, marginBottom: 56,
        }}>
          {/* Brand */}
          <div style={{ maxWidth: 320 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{
                width: 36, height: 36, borderRadius: 9,
                background: 'linear-gradient(135deg, #00C9B1, #7B3FE4)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 16, fontWeight: 800, color: '#fff',
              }}>Q</div>
              <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em', color: '#fff' }}>Qualicore</span>
            </div>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', lineHeight: 1.7, marginBottom: 20 }}>
              GMP Batch-Record Review & Release — the batch-release platform that extends to any extreme.
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {compliance.map(c => (
                <span key={c} style={{
                  fontSize: 10, fontWeight: 600, letterSpacing: '0.06em',
                  color: 'rgba(0,201,177,0.7)', background: 'rgba(0,201,177,0.06)',
                  border: '1px solid rgba(0,201,177,0.15)',
                  padding: '3px 10px', borderRadius: 100, textTransform: 'uppercase',
                }}>{c}</span>
              ))}
            </div>
          </div>

          {/* Nav */}
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', marginBottom: 16 }}>Navigation</p>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {links.map(l => (
                <li key={l.href}>
                  <a href={l.href} style={{
                    fontSize: 14, color: 'rgba(255,255,255,0.5)',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => e.target.style.color = '#fff'}
                  onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.5)'}
                  >{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact CTA */}
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase', marginBottom: 16 }}>Get Started</p>
            <button onClick={onBookDemo} style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '12px 24px', fontSize: 14, fontWeight: 600,
              background: 'linear-gradient(135deg, #00C9B1, #7B3FE4)',
              color: '#fff', borderRadius: 10, border: 'none', cursor: 'pointer',
              fontFamily: 'Inter, sans-serif', transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            >Book a Demo →</button>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', marginTop: 10 }}>Pilot in weeks, not quarters.</p>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.05)',
          paddingTop: 24,
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12,
        }}>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.25)', fontFamily: "'JetBrains Mono', monospace" }}>
            © {new Date().getFullYear()} Qualicore. Validation-ready, not a completed validation.
          </p>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.2)', fontFamily: "'JetBrains Mono', monospace" }}>
            Built on 21 CFR Part 11 · EU Annex 11 & 16 · GAMP 5
          </p>
        </div>
      </div>
    </footer>
  );
}
